import { ReactElement, useCallback, useEffect, useImperativeHandle } from 'react';
import styles from '@/styles/pages/home/menu.module.less';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getHomeSectionIndexByPath, getHomeSectionPath, homeMenu } from '@/services/menu';
import { useLocalStorage } from '@/services';

export interface MenuProps {
    onChangeMenu?: (name: number) => void;
}

const MenuItem = React.forwardRef((props: MenuProps, ref): ReactElement => {
    const { onChangeMenu } = props;
    const history = useNavigate();
    const location = useLocation();
    const __children = [] as ReactElement[];
    const [menuSelectedIndex, setMenuSelectedIndex] = useLocalStorage('menu-selected-index', 0);

    useEffect(() => {
        if (location.pathname === '/admin/home') {
            setMenuSelectedIndex(5);
            return;
        }
        const homeSectionIndex = getHomeSectionIndexByPath(location.pathname);
        if (homeSectionIndex !== undefined) {
            setMenuSelectedIndex(homeSectionIndex);
        }
    }, [location.pathname, setMenuSelectedIndex]);

    homeMenu.forEach((o) => {
        __children.push(
            <div key={o.index} onClick={() => __onChangeMenu(o.index)} className={menuSelectedIndex == o.index ? styles['selected'] : styles['select']}>
                {o.name}
            </div>
        );
    });
    const __onChangeMenu = useCallback((currentIndex: number) => {
        setMenuSelectedIndex(currentIndex);
        if (currentIndex === 4) {
            const w = window.open('about:blank');
            if (w) {
                w.location.href = 'https://aicade-galaxy.gitbook.io/white-paper';
            }
            return;
        }
        if (currentIndex === 5) {
            history('/admin/home');
            return;
        }
        history(getHomeSectionPath(currentIndex));
        onChangeMenu && onChangeMenu(currentIndex);
    }, []);

    useImperativeHandle(ref, () => ({
        gotoPage(pageIndex: number) {
            setMenuSelectedIndex(pageIndex);
        },
    }));

    const menuStyle = { '--menu-selected-index': Number(menuSelectedIndex) || 0 } as React.CSSProperties;

    return (
        <div className={styles['menu']} style={menuStyle}>
            <span className={styles['selected-indicator']} />
            {__children}
        </div>
    );
});

const Menu = React.forwardRef((props: MenuProps, ref): ReactElement => {
    const { onChangeMenu } = props;
    return <MenuItem onChangeMenu={onChangeMenu} ref={ref} />;
});

export default Menu;
